import { createStandaloneToast } from "@chakra-ui/react";

export const { toast, ToastContainer } = createStandaloneToast({
  defaultOptions: {
    status: "error",
    duration: 5000,
    isClosable: true,
    position: "top-right",
  },
});

// export { toast, ToastContainer };
